module.exports = __webpack_public_path__ + "static/img/NSW-20.8009111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-20.jpg
// module id = 5rDa
// module chunks = 0